import { render, staticRenderFns } from "./PersistBoostedDappView.vue?vue&type=template&id=851f23b2"
import script from "./PersistBoostedDappView.vue?vue&type=script&lang=ts"
export * from "./PersistBoostedDappView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports